import { GemeindenMapping, Neighbor } from '../types/neighbor';

class NeighborService {
  private gemeindenMapping: Map<string, Neighbor[]> = new Map();
  private isLoaded = false;

  async loadNeighborData(): Promise<void> {
    if (this.isLoaded) return;

    try {
      const response = await fetch('/data/gemeinden-mapping.json');
      const data: GemeindenMapping = await response.json();

      // Build a map for quick lookup
      data.features.forEach(feature => {
        this.gemeindenMapping.set(
          feature.properties.iso,
          feature.properties.neighbors
        );
      });

      this.isLoaded = true;
    } catch (error) {
      console.error('Failed to load neighbor data:', error);
      throw error;
    }
  }

  async getNeighbors(gemeindeNummer: string): Promise<Neighbor[]> {
    await this.loadNeighborData();
    return this.gemeindenMapping.get(gemeindeNummer) || [];
  }

  async getClosestNeighbors(gemeindeNummer: string, count: number = 2): Promise<Neighbor[]> {
    const neighbors = await this.getNeighbors(gemeindeNummer);
    return neighbors.slice(0, count);
  }
}

export const neighborService = new NeighborService();